import {
  Enticements,
  PlanV2,
  Interval,
} from '@zapier/design-system-revenue/src/types';
import { isMonthly, isYearly } from '@zapier/design-system-revenue/src/utils';

export const calculateDiscount = (
  yearlyAmount: number | undefined,
  monthlyAmount: number | undefined
): number => {
  if (!yearlyAmount || !monthlyAmount) {
    return 0;
  }

  const total = monthlyAmount * 12;
  const discount = total - yearlyAmount;

  return Math.floor((discount / total) * 100);
};

export const getOneEnticement = (
  plans: PlanV2[],
  interval: Interval
): string => {
  if (!isYearly(interval)) {
    return '';
  }

  const yearlyInfo = plans.find(p => isYearly(p.interval));
  const monthlyInfo = plans.find(p => isMonthly(p.interval));

  if (!yearlyInfo || !monthlyInfo) {
    return '';
  }

  if (monthlyInfo.amount * 11 === yearlyInfo.amount) {
    return 'free month';
  }

  const discount = calculateDiscount(yearlyInfo.amount, monthlyInfo.amount);
  return `save ${discount}%`;
};

export const getEnticements = (plans: PlanV2[]): Enticements => {
  return plans.reduce(
    (enticements, plan) => ({
      ...enticements,
      [plan.interval]: getOneEnticement(plans, plan.interval),
    }),
    { year: '', month: '' }
  );
};
